<div
  id="userinfo"
  class="userinfo d-flex items-center g-1"
  routerLink="/profile"
  matTooltip="{{ userInfo.name }}"
  matTooltipPosition="after"
>
  <img [src]="userInfo.ppic" width="50px" height="50px" />
  <div
    *ngIf="isCollapse"
    id="userinfo-text"
    class="userinfo-text d-flex flex-d-column justify-space-evenly"
  >
    <span id="userinfo-text-fullname" class="userinfo-text-fullname">
      {{ userInfo.name }}
    </span>
    <!-- <span id="userinfo-text-courses" class="userinfo-text-courses">
      {{ userInfo.courses }}
    </span> -->
  </div>
</div>
